import React, { useEffect, useState } from "react";
import "./createChannelFirst.css";
import Form from "react-bootstrap/Form";
import CreateSuccessfulChannel from "../Create_successful/CreateSuccessfulChannel";
import axios from "../../../axios";
import Select from "react-select";
// import { Popup } from "semantic-ui-react";
import AddMemebers from "./AddMemebers";
import Popup from "reactjs-popup";
// import "reactjs-popup/dist/index.css";

const CreateChannelFirst = ({ change }) => {
  const [channel, setChannel] = useState({
    addMembers: false,
  });
  const [openSuccessfull, setOpenSuccessfull] = useState(false);

  const [communityDetails, setCommunityDetails] = useState({
    name: null,
    description: null,
    profilePicture: null,
    isValid: true,
  });

  const { profilePicture, name, description, isValid } = communityDetails;
  useEffect(() => {
    if (name && name !== "" && description && description !== "") {
      setCommunityDetails({ ...communityDetails, isValid: false });
    } else {
      setCommunityDetails({ ...communityDetails, isValid: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [description, name]);

  return (
    <>
      {!openSuccessfull ? (
        <div className="create_channel_transprant_body">
          <div className=" px-4 py-3 create_channel_container">
            <img
              src="/images/cross-circle3.svg"
              className="channel_crossArrow"
              alt=""
              onClick={(e) => change(false)}
            />

            <div className="mb-4 create_channel_header">Create Channel</div>
            {!channel.addMembers && (
              <form>
                <div className="photoUploadHeader">Photo Upload</div>
                <div className="uploadImg_container">
                  <img
                    src={`${profilePicture
                      ? URL.createObjectURL(profilePicture)
                      : "/images/uploadBackgroundimg.png"
                      }`}
                    className="uploadImage"
                    alt="uploadimg"
                  />

                  {!profilePicture ? (
                    <>
                      <input
                        type="file"
                        id="attachFileIcon"
                        accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx"
                        style={{ display: "none" }}
                        onChange={(e) =>
                          setCommunityDetails({
                            ...communityDetails,
                            profilePicture: e.target.files[0],
                          })
                        }
                      />
                      <label htmlFor="attachFileIcon">
                        <img
                          src="/images/CameraIcon.png"
                          className="cameraIcon"
                          alt="cameraIcon"
                        />
                      </label>
                    </>
                  ) : (
                    <Popup
                      trigger={
                        <img
                          src="/images/CameraIcon.png"
                          className="cameraIcon"
                          alt="cameraIcon"
                        />
                      }
                      position="bottom center"
                    >
                      <div className="container_threedot">
                        <input
                          type="file"
                          id="attachFile"
                          style={{ display: "none" }}
                          accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx"
                          onChange={(e) =>
                            setCommunityDetails({
                              ...communityDetails,
                              profilePicture: e.target.files[0],
                            })
                          }
                        />
                        <label htmlFor="attachFile">
                          <div className="PopupThreedots">Edit</div>
                        </label>
                        <div
                          className="PopupThreedots"
                          onClick={(e) =>
                            setCommunityDetails({
                              ...communityDetails,
                              profilePicture: null,
                            })
                          }
                        >
                          Remove
                        </div>
                      </div>
                    </Popup>
                  )}
                </div>
                <div className="photoUploadHeader mt-2 d-flex align-items-center">
                  <span className="create_channel_input_heading">
                    Channel Name
                  </span>
                  <span
                    className="ml-1"
                    style={{ color: "red", fontSize: "12px" }}
                  >
                    {/* * */}
                  </span>
                </div>
                <input
                  className="ChanelDecription_input"
                  required
                  value={name}
                  onChange={(e) => {
                    if (e.target.value.trim() !== "") {
                      setCommunityDetails({
                        ...communityDetails,
                        name: e.target.value,
                      });
                    } else {
                      setCommunityDetails({
                        ...communityDetails,
                        name: e.target.value,
                      });
                    }
                  }}
                  maxLength={200}
                  placeholder="Enter channel name"
                />
                <div className="photoUploadHeader mt-2 d-flex align-items-center">
                  <span className="create_channel_input_heading">
                    Channel Description
                  </span>
                  <span
                    className="ml-1"
                    style={{ color: "red", fontSize: "12px" }}
                  >
                    {/* * */}
                  </span>
                </div>
                <input
                  className="ChanelDecription_input "
                  required
                  value={description}
                  onChange={(e) => {
                    if (e.target.value.trim() !== "") {
                      setCommunityDetails({
                        ...communityDetails,
                        description: e.target.value,
                      });
                    } else {
                      setCommunityDetails({
                        ...communityDetails,
                        description: null,
                      });
                    }
                  }}
                  maxLength={500}
                  placeholder="Two line description"
                />

                <div className="mt-4 d-flex justify-content-between align-items-center create_btn_box ">
                  <div className="pageNumber">1/2</div>
                  <button
                    type="submit"
                    disabled={isValid}
                    onClick={(e) =>
                      setChannel({
                        ...channel,
                        addMembers: true,
                      })
                    }
                    className={`btn btn-danger create_Btn ${isValid && "not_allowed"
                      }`}
                  >
                    Next
                  </button>
                </div>
              </form>
            )}

            {channel.addMembers && (
              <AddMemebers
                communityDetails={communityDetails}
                setOpenSuccessfull={setOpenSuccessfull}
                setChannel={setChannel}
              />
            )}
          </div>
        </div>
      ) : (
        <CreateSuccessfulChannel />
      )}
    </>
  );
};

export default CreateChannelFirst;
